import { MenuItem } from '@material-ui/core';
import React from 'react';

import useLocations from 'core/hooks/useLocations';
import { InputField, InputFieldProps } from 'Elements/Form';

export default function LocationSelect({
  name = 'location_id',
  ...props
}: InputFieldProps) {
  const locations = useLocations();

  return (
    <InputField
      name={name}
      select
      margin="normal"
      InputLabelProps={{
        shrink: true
      }}
      {...props}
    >
      {locations.map(location => (
        <MenuItem key={location.id} value={location.id}>
          {location.name}
        </MenuItem>
      ))}
    </InputField>
  );
}
